// extracted by mini-css-extract-plugin
module.exports = {"media":"MediaContainer_media__1N8XB","section":"MediaContainer_section__LyRie","imageText":"MediaContainer_imageText__3_q2Z"};